import {Component, Fragment, h} from 'preact'
import styles from "./style.module.scss"
import {connect} from "redux-zero/preact";
import actions from "../../../store/actions";
import {withDeviceIndicator} from "../../../hoc/withDeviceIndicator";
import {Collection} from "../../../models/collection";
import {FilterMap} from "../../../models/filter";
import {imageService} from "../../../services/image-service";
import {Product} from "../../../models/product";
import ProductItem from "../../product-item";

interface Props {
    collection: Collection;
    products: Product[];
    filters: FilterMap;
    isMobile: boolean;
    initialized: boolean;
}

const mapToProps = ({collections, filters, initialized}) => ({collections, filters, initialized});


class PortraitOnly extends Component<Props, any> {

    render(props: Readonly<Props>) {

        if (!this.props.initialized) {
            return;
        }

        const collection = {...this.props.collection} as Collection
        const products = [...this.props.products] as Product[]

        if (this.props.initialized && collection && products && this.props.isMobile) {
            const images = collection.outfits.map(o => o.image_key);
            const descriptions = collection.outfits.map(o => o.descriptions[this.props.filters.country]);
            return (
                <div class={styles['editorial-container-mobile']}>
                    {products.map((product, index) => {
                        return (
                            <div class={styles['outfit']}>
                                {images.length >= 1 &&
                                    <div class={styles['outfit-image']}>
                                        <img
                                            src={imageService.getImageUrlInFormat(images.shift(), '2_3')}
                                            alt={descriptions.shift()}/>
                                    </div>
                                }
                                <div class={styles['products']}>
                                    {products.splice(0, products.length >= 6 ? 6 : products.length).map((p) => {
                                        return (
                                            <div class={styles['product']}>
                                                <ProductItem product={p} forceCutout={true}/>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        );
                    })}
                </div>
            );
        }
        if (this.props.initialized && collection && products) {
            const imageAmount = Math.floor((products.length / 6));
            const images = collection.outfits.map(o => o.image_key);
            const descriptions = collection.outfits.map(o => o.descriptions[this.props.filters.country]);
            const MAX_IMAGES_PER_ROW = 3;
            const hiddenContainers = MAX_IMAGES_PER_ROW - (products.length % MAX_IMAGES_PER_ROW);

            return (
                <div class={styles['editorial-container-desktop']}>
                    {products.map((product, index) => {
                        return (
                            <Fragment>
                                {index === 0 && <div class={styles['row-1']}>
                                    <div class={styles['key-image']}
                                         style={{backgroundImage: `url(${imageService.getImageUrlInFormat(images.shift(), '2_3')})`}}
                                         title={descriptions.shift() ?? product.variants[0].productId}>
                                    </div>
                                    <div class={styles['key-products']}>
                                        {products.splice(0, 2).map((p) => {
                                            return (
                                              <div class={styles['product']}>
                                              <ProductItem product={p} dimension={'Collection'}
                                                                 forceCutout={true}/>
                                                </div>
                                            );
                                        })}
                                    </div>
                                    <div class={styles['remaining-key-products']}>
                                        {products.splice(0, 3).map((p) => {
                                            return (
                                                <div class={styles['product']}>
                                                    <ProductItem product={p} dimension={'Collection'}
                                                                 forceCutout={true}/>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>}
                                {products.length >= 1 && images.length >= 1 &&
                                    <div class={styles['row-1']}>
                                        <div className={styles['key-products']}>
                                            {products.splice(0, 2).map((p) => {
                                                return (
                                                    <div class={styles['product']}>
                                                        <ProductItem product={p} dimension={'Collection'}
                                                                     forceCutout={true}/>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                        <div className={styles['key-image']}
                                             style={{backgroundImage: `url(${imageService.getImageUrlInFormat(images.shift(), '2_3')})`}}
                                             title={descriptions.shift() ?? product.variants[0].productId}>
                                        </div>
                                        <div className={styles['remaining-key-products']}>
                                            {products.splice(0, 3).map((p) => {
                                                return (
                                                  <div className={styles['product']}>
                                                        <ProductItem product={p} dimension={'Collection'}
                                                                     forceCutout={true}/>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>}
                                {products.length >= 1 && images.length >= 1 &&
                                    <div class={styles['row-1']}>
                                        <div className={styles['key-image']}
                                             style={{backgroundImage: `url(${imageService.getImageUrlInFormat(images.shift(), '2_3')})`}}
                                             title={descriptions.shift() ?? product.variants[0].productId}>
                                        </div>
                                        <div className={styles['key-products']}>
                                            {products.splice(0, 2).map((p) => {
                                                return (
                                                  <div class={styles['product']}>
                                                        <ProductItem product={p} dimension={'Collection'}
                                                                     forceCutout={true}/>
                                                    </div>
                                                );
                                            })}

                                        </div>
                                    </div>}
                                <div class={styles['row-3']}>
                                    {imageAmount >= 1
                                        ? products.splice(0, 6).map((p) => {
                                            return (
                                                <div class={styles['product']}>
                                                    <ProductItem product={p} dimension={'Collection'}
                                                                 forceCutout={true}/>
                                                </div>
                                            );
                                        })
                                        : products.map((p) => {
                                            return (
                                                <div class={styles['product']}>
                                                    <ProductItem product={p} dimension={'Collection'}
                                                                 forceCutout={true}/>
                                                </div>
                                            );
                                        })
                                    }
                                    {/*
                   Fill with hidden Items to fit the item count of the last row
                   Sources: https://stackoverflow.com/a/40936683, https://stackoverflow.com/a/47826868
                  */}
                                    {Array.apply(null, {length: hiddenContainers}).map(() =>
                                        <div class={styles['product']}>
                                            <a class={styles.hidden}/>
                                        </div>
                                    )}
                                </div>
                            </Fragment>
                        )
                    })}
                </div>
            );
        }
    }
}

export default connect(mapToProps, actions)(withDeviceIndicator(PortraitOnly))
